<button class="icon icon-close" (click)="closeClicked.emit()"></button>

@if (devMode) {
    <div class="dev">{{ enabledGamesVisualization }}</div>
}

<div #gamesContainer class="observer-root hide-scrollbar" (scroll)="onScroll($event)">
    <div *ngIf="loading" class="spinner-container">
        <div class="spinner"></div>
    </div>

    <div *ngIf="!loading" class="games-holder">
        @for (game of games; track game.gameNumber; let index = $index) {
            <div class="observer-target" [attr.data-target-index]="index">
                @if (game.enabled) {
                    <div class="game-holder">
                        <div class="header">
                            <h3 i18n>{{ game.displayName }}</h3>
                            <ul>
                                <li i18n>ID: {{ game.gameNumber }}</li>
                                <li i18n>{{ game.timestamp | date: 'd/M/y - h:mm:ss a' }}</li>
                            </ul>
                        </div>
                        <app-game-switch [gameInstance]="game.gameInstance" [isVoid]="game.isVoid"></app-game-switch>
                    </div>
                }
            </div>
        }
    </div>
</div>

<app-pagination
    *ngIf="!loading"
    [totalPages]="games.length"
    [(pageIndex)]="pageIndex"
    (pageIndexChange)="updatePageIndex($event)"
></app-pagination>

@if (!loading && sliderEnabled) {
    <input type="range" min="0" [max]="games.length - 1" [value]="pageIndex" (input)="onSlide($event)" />
}
